module.exports = __webpack_public_path__ + "img/conve_text2.0e218813.png";